module.exports = __webpack_public_path__ + "static/media/photo144.b840e08b.jpg";